import * as Types from '../../../__generated__/api/types';

import gql from '@tv2-player/unifiedplayer/gqlToString';
export type PlayUnifiedLiveTrackingQueryVariables = Types.Exact<{
  guid: Types.Scalars['String']['input'];
  nielsenTrackingVersion?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type PlayUnifiedLiveTrackingQuery = {
  tracking:
    | {
        __typename: 'LiveTracking';
        nielsen: {
          __typename: 'DetailedNielsenList';
          nodes: Array<{
            __typename: 'DetailedNielsen';
            trackingObject: string | null;
            ad: boolean | null;
            start: number | null;
            stop: number | null;
          } | null> | null;
          active: {
            __typename: 'DetailedNielsen';
            trackingObject: string | null;
            ad: boolean | null;
            start: number | null;
            stop: number | null;
          } | null;
        } | null;
        adobe: {
          __typename: 'DetailedAdobeBlockList';
          nodes: Array<{
            __typename: 'DetailedAdobeBlock';
            prerolls: {
              __typename: 'DetailedAdobeList';
              nodes: Array<{
                __typename: 'DetailedAdobe';
                id: string | null;
                title: string | null;
                duration: number | null;
                broadcast: string | null;
                ad: boolean | null;
                start: number | null;
                stop: number | null;
                startOverAvailable: boolean | null;
              } | null> | null;
            } | null;
            program: {
              __typename: 'DetailedAdobe';
              id: string | null;
              title: string | null;
              duration: number | null;
              broadcast: string | null;
              ad: boolean | null;
              start: number | null;
              stop: number | null;
              startOverAvailable: boolean | null;
            } | null;
          } | null> | null;
          active: {
            __typename: 'DetailedAdobeBlock';
            program: {
              __typename: 'DetailedAdobe';
              id: string | null;
              title: string | null;
              duration: number | null;
              broadcast: string | null;
              ad: boolean | null;
              start: number | null;
              stop: number | null;
              startOverAvailable: boolean | null;
            } | null;
          } | null;
        } | null;
      }
    | { __typename: 'VodTracking' }
    | null;
  entity:
    | { __typename: 'Broadcast'; epgUpdateInterval: number | null; epgUpdateType: string | null }
    | { __typename: 'Episode' }
    | { __typename: 'Event' }
    | { __typename: 'Movie' }
    | { __typename: 'Program' }
    | { __typename: 'Series' }
    | { __typename: 'SportingEvent' }
    | { __typename: 'Station' }
    | null;
};

export type NielsenTrackingFragment = {
  __typename: 'LiveTracking';
  nielsen: {
    __typename: 'DetailedNielsenList';
    nodes: Array<{
      __typename: 'DetailedNielsen';
      trackingObject: string | null;
      ad: boolean | null;
      start: number | null;
      stop: number | null;
    } | null> | null;
    active: {
      __typename: 'DetailedNielsen';
      trackingObject: string | null;
      ad: boolean | null;
      start: number | null;
      stop: number | null;
    } | null;
  } | null;
};

export type AdobeTrackingFragment = {
  __typename: 'LiveTracking';
  adobe: {
    __typename: 'DetailedAdobeBlockList';
    nodes: Array<{
      __typename: 'DetailedAdobeBlock';
      prerolls: {
        __typename: 'DetailedAdobeList';
        nodes: Array<{
          __typename: 'DetailedAdobe';
          id: string | null;
          title: string | null;
          duration: number | null;
          broadcast: string | null;
          ad: boolean | null;
          start: number | null;
          stop: number | null;
          startOverAvailable: boolean | null;
        } | null> | null;
      } | null;
      program: {
        __typename: 'DetailedAdobe';
        id: string | null;
        title: string | null;
        duration: number | null;
        broadcast: string | null;
        ad: boolean | null;
        start: number | null;
        stop: number | null;
        startOverAvailable: boolean | null;
      } | null;
    } | null> | null;
    active: {
      __typename: 'DetailedAdobeBlock';
      program: {
        __typename: 'DetailedAdobe';
        id: string | null;
        title: string | null;
        duration: number | null;
        broadcast: string | null;
        ad: boolean | null;
        start: number | null;
        stop: number | null;
        startOverAvailable: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type AdobeNodeTrackingFragment = {
  __typename: 'DetailedAdobeBlock';
  prerolls: {
    __typename: 'DetailedAdobeList';
    nodes: Array<{
      __typename: 'DetailedAdobe';
      id: string | null;
      title: string | null;
      duration: number | null;
      broadcast: string | null;
      ad: boolean | null;
      start: number | null;
      stop: number | null;
      startOverAvailable: boolean | null;
    } | null> | null;
  } | null;
  program: {
    __typename: 'DetailedAdobe';
    id: string | null;
    title: string | null;
    duration: number | null;
    broadcast: string | null;
    ad: boolean | null;
    start: number | null;
    stop: number | null;
    startOverAvailable: boolean | null;
  } | null;
};

export type AdobeProgramTrackingFragment = {
  __typename: 'DetailedAdobe';
  id: string | null;
  title: string | null;
  duration: number | null;
  broadcast: string | null;
  ad: boolean | null;
  start: number | null;
  stop: number | null;
  startOverAvailable: boolean | null;
};

export type LiveTrackingFragment = {
  __typename: 'LiveTracking';
  nielsen: {
    __typename: 'DetailedNielsenList';
    nodes: Array<{
      __typename: 'DetailedNielsen';
      trackingObject: string | null;
      ad: boolean | null;
      start: number | null;
      stop: number | null;
    } | null> | null;
    active: {
      __typename: 'DetailedNielsen';
      trackingObject: string | null;
      ad: boolean | null;
      start: number | null;
      stop: number | null;
    } | null;
  } | null;
  adobe: {
    __typename: 'DetailedAdobeBlockList';
    nodes: Array<{
      __typename: 'DetailedAdobeBlock';
      prerolls: {
        __typename: 'DetailedAdobeList';
        nodes: Array<{
          __typename: 'DetailedAdobe';
          id: string | null;
          title: string | null;
          duration: number | null;
          broadcast: string | null;
          ad: boolean | null;
          start: number | null;
          stop: number | null;
          startOverAvailable: boolean | null;
        } | null> | null;
      } | null;
      program: {
        __typename: 'DetailedAdobe';
        id: string | null;
        title: string | null;
        duration: number | null;
        broadcast: string | null;
        ad: boolean | null;
        start: number | null;
        stop: number | null;
        startOverAvailable: boolean | null;
      } | null;
    } | null> | null;
    active: {
      __typename: 'DetailedAdobeBlock';
      program: {
        __typename: 'DetailedAdobe';
        id: string | null;
        title: string | null;
        duration: number | null;
        broadcast: string | null;
        ad: boolean | null;
        start: number | null;
        stop: number | null;
        startOverAvailable: boolean | null;
      } | null;
    } | null;
  } | null;
};

export const NielsenTrackingFragment = gql`
  fragment nielsenTrackingFragment on LiveTracking {
    nielsen {
      nodes {
        trackingObject
        ad
        start
        stop
      }
      active {
        trackingObject
        ad
        start
        stop
      }
    }
  }
`;
export const AdobeProgramTrackingFragment = gql`
  fragment adobeProgramTrackingFragment on DetailedAdobe {
    id
    title
    duration
    broadcast
    ad
    start
    stop
    id
    startOverAvailable
  }
`;
export const AdobeNodeTrackingFragment = gql`
  fragment adobeNodeTrackingFragment on DetailedAdobeBlock {
    prerolls {
      nodes {
        ...adobeProgramTrackingFragment
      }
    }
    program {
      ...adobeProgramTrackingFragment
    }
  }
`;
export const AdobeTrackingFragment = gql`
  fragment adobeTrackingFragment on LiveTracking {
    adobe {
      nodes {
        ...adobeNodeTrackingFragment
      }
      active {
        program {
          ...adobeProgramTrackingFragment
        }
      }
    }
  }
`;
export const LiveTrackingFragment = gql`
  fragment liveTrackingFragment on LiveTracking {
    ...nielsenTrackingFragment
    ...adobeTrackingFragment
  }
`;
export const PlayUnifiedLiveTracking = gql`
  query play_unified_live_tracking($guid: String!, $nielsenTrackingVersion: String) {
    tracking(guid: $guid, nielsenVersion: $nielsenTrackingVersion) {
      __typename
      ...liveTrackingFragment
    }
    entity(guid: $guid) {
      __typename
      ... on Broadcast {
        epgUpdateInterval
        epgUpdateType
      }
    }
  }
  ${LiveTrackingFragment}
  ${NielsenTrackingFragment}
  ${AdobeTrackingFragment}
  ${AdobeNodeTrackingFragment}
  ${AdobeProgramTrackingFragment}
`;
